import type { ContentfulSysProps } from '../../types/contentful';
import type { ImageDataProps } from './types';

export const isImageDataProps = (props: ContentfulSysProps): props is ImageDataProps => {
  return props.__typename === 'Image';
};
